import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { GraduationCap, LogOut, Home, LayoutDashboard, BookOpen, ClipboardCheck, CalendarDays } from "lucide-react";

const NAV = [
  { to: "/schulungen/teilnehmer", label: "Übersicht", icon: LayoutDashboard, end: true, testId: "tn-nav-uebersicht" },
  { to: "/schulungen/teilnehmer/modul/m1", label: "Lernen", icon: BookOpen, match: "/schulungen/teilnehmer/modul", testId: "tn-nav-lernen" },
  { to: "/schulungen/teilnehmer/test", label: "Abschlusstest", short: "Test", icon: ClipboardCheck, testId: "tn-nav-test" },
  { to: "/schulungen/teilnehmer/termine", label: "Online-Präsenz", short: "Termine", icon: CalendarDays, testId: "tn-nav-termine" },
];

export default function TeilnehmerLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = () => { logout(); navigate("/schulungen/login"); };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="teilnehmer-portal">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
          <Link to="/schulungen/teilnehmer" className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-xl bg-cyan-700 text-white flex items-center justify-center"><GraduationCap className="h-5 w-5" /></div>
            <div><p className="text-sm font-bold text-slate-800 font-['Manrope']">Mein Lernbereich</p><p className="text-[11px] text-cyan-600 font-semibold tracking-wider uppercase">Basisqualifikation § 45b</p></div>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/schulungen" className="hidden sm:inline-flex items-center gap-1.5 px-3 py-2 text-sm text-slate-500 hover:text-slate-800 rounded-lg hover:bg-slate-50"><Home className="h-4 w-4" />Schulungsseite</Link>
            <button onClick={handleLogout} data-testid="teilnehmer-logout-btn" className="inline-flex items-center gap-1.5 px-3 py-2 text-sm text-slate-500 hover:text-red-600 rounded-lg hover:bg-red-50"><LogOut className="h-4 w-4" />Abmelden</button>
          </div>
        </div>
        <nav className="max-w-5xl mx-auto px-4 sm:px-6 flex gap-1 overflow-x-auto pb-2 -mt-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={n.testId}
              className={({ isActive }) => `inline-flex items-center gap-1.5 px-2.5 sm:px-3 py-2 rounded-lg text-xs sm:text-sm font-semibold whitespace-nowrap transition-colors ${isActive || (n.match && window.location.pathname.startsWith(n.match)) ? "bg-cyan-700 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
              <n.icon className="h-4 w-4" /><span className="sm:hidden">{n.short || n.label}</span><span className="hidden sm:inline">{n.label}</span>
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
